export default __webpack_public_path__ + "assets/images/histBeforeTopHat-e0166628b2bd8b53e6349aa9f52e3e7a.svg";